import { createAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { TemplateVersionShallow } from '../../core';
import { ActionType } from '../main.action';

export interface Reload {
    user?: User;
    templateVersionId?: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.EVAL_MAIN__RELOAD,
);

export interface ReloadResult extends Reload {
    templateVersions?: TemplateVersionShallow[];
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.EVAL_MAIN__RELOAD_RESULT,
);
